import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import GatewayComponent, { PlatformDBAServicesComponent } from '../component/platform-dba-service.component';
import { selectDbasListItems } from '../../../../../redux/dbas/selector';
import { dbas } from '../../../../../redux/dbas/action';
import { selectPlatformDBAServicesQueryItems } from '../../../../../redux/platform-dba-services/selector';
import { platformDBAServices } from '../../../../../redux/platform-dba-services/action';


const PlatformDBAService= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectPlatformDBAServicesQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
      const dbasItems = useSelector(selectDbasListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedService,
    setSelectedService
  ] = useState<any>([])
 
  const fetchgatewayById= ()=>{
    dispatch(platformDBAServices.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dba-services/query`,entity:'platformDBAServices',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedService({ ...selectedService, [field]: event });
  }

  useEffect(
    () => {
        dispatch(dbas.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dbas/list`,entity:'domains',jsonData:{
                }}))
      if (parmas?.id > 0) {
        fetchgatewayById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedService(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(platformDBAServices.resetAction({ actionType: 'update' }))
     await dispatch(platformDBAServices.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dba-services`,entity:'platformDBAServices',jsonData:{
          
    Records: [
      {
        
       
         ...selectedService
        
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(platformDBAServices.resetAction({ actionType: 'create' }))
      await dispatch(platformDBAServices.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dba-services`,entity:'platformDBAServices',jsonData:{
          
      Records: [
        {
        
         
            ...selectedService
          
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/platform-dba-services')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <PlatformDBAServicesComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedService={selectedService}
           back={back}
           handleFormSubmit={handleFormSubmit}
           dbas={dbasItems?.result?.items}
           id={parmas?.id}
          /> 
    } 
          </>
    )
    
    }
   
    export default PlatformDBAService;
